module.exports = __webpack_public_path__ + "img/select2.0e0242ab.png";